export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Header.vue?vue&type=template&id=ba3abd38&"


//////////////////
// WEBPACK FOOTER
// ./src/components/header/Header.vue?vue&type=template&id=ba3abd38&
// module id = 884
// module chunks = 0